module.exports = __webpack_public_path__ + "img/组 25@2x.87f0a5ba.png";